import { z } from 'zod';

// `reason` is optional, per the docs — an admin can close an investment
// with no explanation given. Capped at 500 characters to match the
// server's own limit, surfaced client-side via a character counter rather
// than just waiting for the 422.
export const closeInvestmentSchema = z.object({
  reason: z.string().max(500, 'Reason must be 500 characters or fewer').optional(),
});

export default closeInvestmentSchema;
